export type PaymentSuccessResult = {
  kind: 'success'
  receiptId: number | null
  receiptHtml: string | null
  message: string | null
}

export type PaymentErrorResult = {
  kind: 'error'
  message: string
}

export type PaymentResult = PaymentSuccessResult | PaymentErrorResult

const DEFAULT_CHARGE_ERROR = 'Charge failed'

const asNonEmptyString = (value: unknown): string | null =>
  typeof value === 'string' && value.length > 0 ? value : null

export const parsePayEncounterResponse = (response: unknown): PaymentResult | null => {
  if (!response || typeof response !== 'object') return null
  const record = response as Record<string, unknown>
  const hasStatus = typeof record.status === 'boolean'
  const hasSuccess = typeof record.success === 'boolean'
  if (!hasStatus && !hasSuccess) return null

  if (record.status === false || record.success === false) {
    return { kind: 'error', message: asNonEmptyString(record.message) ?? DEFAULT_CHARGE_ERROR }
  }

  return {
    kind: 'success',
    receiptId: typeof record.receipt_id === 'number' ? record.receipt_id : null,
    receiptHtml: asNonEmptyString(record.receipt_html),
    message: asNonEmptyString(record.message),
  }
}

export const getChargeErrorDescription = (error: unknown): string => {
  const record = error && typeof error === 'object' ? (error as Record<string, unknown>) : null
  const rawData = record?.data

  let messageFromData: string | null = null
  if (Array.isArray(rawData)) {
    messageFromData =
      rawData.find((entry): entry is string => typeof entry === 'string' && entry.length > 0) ??
      null
  } else if (rawData && typeof rawData === 'object') {
    messageFromData = asNonEmptyString((rawData as Record<string, unknown>).message)
  } else {
    messageFromData = asNonEmptyString(rawData)
  }

  return messageFromData ?? asNonEmptyString(record?.message) ?? DEFAULT_CHARGE_ERROR
}
